<app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categories" [label]="themeOptions.optionsConfiguration[optionType].label" [limitedTo]="themeOptions.limitedTo(optionType)" [information]="themeOptions.axes(axesXY, axesIndex).scaleLabel.fontColor">
  <div app-theme-option-content>
    <app-show-details-option [showDetails]="showDetails" (sendShowDetails)="receiveShowDetails($event)">
      <div app-show-details-option-content>
        <app-color-picker [itemColor]="color" [color]="themeOptions.axes(axesXY, axesIndex).scaleLabel.fontColor" (sendColor)="receiveValue($event)"></app-color-picker>
      </div>
    </app-show-details-option>
  </div>
</app-theme-option>

<div *ngIf="showDetails">
  <app-theme-option [categories]="themeOptions.optionsConfiguration[optionType].categoriesAndLabel" [label]="type | chart" [dark]="4" *ngFor="let type of themeOptions.limitedTo(optionType)" [information]="themeOptions.axes(axesXY, axesIndex, type).scaleLabel.fontColor">
    <div app-theme-option-content>
      <app-color-picker [itemColor]="color" [color]="themeOptions.axes(axesXY, axesIndex, type).scaleLabel.fontColor" (sendColor)="receiveValue($event, type)"></app-color-picker>
    </div>
  </app-theme-option>
</div>